import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeLangAction } from "../../actions/WelcomeActions";
import { appendUid } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import isIos from "is-ios";
import { isGamiclub } from "../../constants/isGamiclub";
import { isAppspool } from "../../constants/isAppspool";
import { isGamezClan } from "../../constants/isGamezClan";
import { isOnlyMobbfun } from "../../constants/isOnlyMobbfun";
import { isOnlyBeemobi } from "../../constants/isOnlyBeemobi";
import {
  isGameflares,
  isGamelords,
  isGamiway,
} from "../../constants/productCondition";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";
var arabicDomain,
  kazakhDomain,
  frenchDomain,
  swedishDomain,
  belgiumDomain,
  norwayDomain,
  asiacellDomain,
  vietnamDomain,
  myDomain,
  turkeyDomain,
  maseDomain,
  spanishDomain,
  italianDomain,
  rsDomain,
  deDomain,
  roDomain;

const getContactPageURL = () => {
  const onlyGamelords = !isGamiclub && !isGamezClan;
  const onlyGamiclub = isGamiclub && !isOnlyMobbfun && !isOnlyBeemobi;
  let cucaURL = "https://game-lords.com";
  if (onlyGamiclub) cucaURL = "https://gamiclub.com";
  const subdomains = ["sa", "ae", "kw", "rs"];
  if (subdomains.indexOf(config.subDomain) >= 0)
    return `${cucaURL}/customer-care/?subdomain=${config.subDomain}`;
  else return undefined;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAndroid: false,
      openHtml: false,
      openNotification: false,
      openLanguage: false,
    };

    this.hideSideBar = this.hideSideBar.bind(this);
    this.changeDomain = this.changeDomain.bind(this);
  }

  handleClick(name, e) {
    e.preventDefault();
    switch (name) {
      case "html5": {
        this.setState({
          openHtml: !this.state.openHtml,
          openAndroid: false,
          openNotification: false,
          openLanguage: false,
        });
        break;
      }
      case "android": {
        this.setState({
          openAndroid: !this.state.openAndroid,
          openHtml: false,
          openNotification: false,
          openLanguage: false,
        });
        break;
      }
      case "notification": {
        this.setState({
          openNotification: !this.state.openNotification,
          openHtml: false,
          openAndroid: false,
          openLanguage: false,
        });
        break;
      }
      case "language": {
        this.setState({
          openLanguage: !this.state.openLanguage,
          openHtml: false,
          openAndroid: false,
          openNotification: false,
        });
        break;
      }
    }
  }

  translateCat(categoriesArr, lang) {
    let translatedCatArr = categoriesArr.map((cat) => {
      let englishCat = [
        "Premium Games",
        "Action",
        "Adventure",
        "RPG",
        "Virtual Reality",
        "Arcade",
        "Racing",
        "Sports",
      ];
      let arabicCat = [
        "العاب مميزه",
        "الاكشن",
        "المغامرات",
        "العاب ار بي جي",
        "الواقع الافتراضي",
        "مغامرات",
        "سباق",
        "الرياضه",
      ];
      let kazakhCat = [
        "Премиум игры",
        "Экшн",
        "Приключения",
        "RPG",
        "Виртуальная реальность",
        "Аркады",
        "Гонки",
        "Спорт",
      ];
      let frenchCat = [
        "Jeux Premium",
        "Action",
        "Aventure",
        "RPG",
        "Réalité virtuelle",
        "Arcade",
        "Course",
        "Sports",
      ];
      let swedishCat = [
        "Premium-spel",
        "Action",
        "Äventyr",
        "RPG",
        "Virtual Reality",
        "Arkad",
        "Racing",
        "Sporter",
      ];
      let belgiumCat = [
        "Premium spelletjes",
        "Actie",
        "Avontuur",
        "RPG",
        "Virtuele realiteit",
        "Arcade",
        "Racen",
        "Sport",
      ];
      let norwayCat = [
        "Premium-spill",
        "Action",
        "Eventyr",
        "RPG",
        "Virtuell virkelighet",
        "Arkade",
        "Racing",
        "Sport",
      ];
      let vietnamCat = [
        "Games độc quyền",
        "Hành động",
        "Phiêu lưu",
        "RPG",
        "Thực tế ảo",
        "Nhập vai",
        "Đua xe",
        "Thể thao",
      ];
      let turkeyCat = [
        "Premium Oyunlar   ",
        "Aksiyon",
        "Macera",
        "RPG",
        "Sanal Gerçeklik",
        "Arcade oyun",
        "Yarış ",
        "Spor",
      ];
      let spanishCat = [
        "Juegos prémium",
        "Acción",
        "Aventura",
        "RPG",
        "Realidad Virtual",
        "Arcade",
        "Correr",
        "Deporte",
      ];
      let italianCat = [
        "Giochi premium",
        "Azione",
        "Avventura",
        "RPG",
        "Realtà virtuale",
        "Arcade",
        "Corsa",
        "Sport",
      ];
      let greekCat = [
        "Premium παιχνίδια",
        "Δράση",
        "Περιπέτεια",
        "Παιχνίδια RPG",
        "Εικονική πραγματικότητα",
        "Ηλεκτρονικά παιχνίδια",
        "Αγώνες αυτοκινήτου",
        "Σπορ",
      ];

      let index = englishCat.indexOf(cat.categoryName);
      if (index != -1) {
        if (lang == "ar") {
          cat = { ...cat, categoryNameTranslated: arabicCat[index] };
        } else if (lang == "kk") {
          cat = { ...cat, categoryNameTranslated: kazakhCat[index] };
        } else if (lang == "fr") {
          cat = { ...cat, categoryNameTranslated: frenchCat[index] };
        } else if (lang == "sv") {
          cat = { ...cat, categoryNameTranslated: swedishCat[index] };
        } else if (lang == "be") {
          cat = { ...cat, categoryNameTranslated: belgiumCat[index] };
        } else if (lang == "no") {
          cat = { ...cat, categoryNameTranslated: norwayCat[index] };
        } else if (lang == "vi") {
          cat = { ...cat, categoryNameTranslated: vietnamCat[index] };
        } else if (lang == "tr") {
          cat = { ...cat, categoryNameTranslated: turkeyCat[index] };
        } else if (lang == "es") {
          cat = { ...cat, categoryNameTranslated: spanishCat[index] };
        } else if (lang == "it") {
          cat = { ...cat, categoryNameTranslated: italianCat[index] };
        } else if (lang == "el") {
          cat = { ...cat, categoryNameTranslated: greekCat[index] };
        }
      }
      return cat;
    });
    return translatedCatArr;
  }

  hideSideBar() {
    document.body.classList.toggle("sidebar-hidden");
    document.body.classList.toggle("sidebar-mobile-show");
  }

  handleChange(event) {
    this.props.changeLang(event);
    this.props.changeLangAction({
      currentLang: event,
    });

    this.setState({});
  }
  changeDomain() {
    arabicDomain = config.lang == "ar" ? true : false;
    kazakhDomain = config.lang == "kk" ? true : false;
    frenchDomain = config.subDomain == "ci" ? true : false;
    swedishDomain = config.lang == "sv" ? true : false;
    belgiumDomain = config.lang == "be" ? true : false;
    norwayDomain = config.lang == "no" ? true : false;
    asiacellDomain =
      config.subDomain == "iq" || config.subDomain == "asiacell" ? true : false;
    vietnamDomain = config.lang == "vi" ? true : false;
    myDomain = config.subDomain == "my" ? true : false;
    turkeyDomain = config.subDomain == "tr" ? true : false;
    maseDomain = config.subDomain == "mase" ? true : false;
    spanishDomain = config.subDomain == "es" ? true : false;
    italianDomain = config.subDomain == "it" ? true : false;
    rsDomain = config.subDomain == "rs" ? true : false;
    deDomain = config.subDomain == "ch" ? true : false;
    roDomain = config.subDomain == "ro" ? true : false;
  }

  getUnsubLink() {
    const uid = this.props.access.uid;
    if (!uid) return "";
    if (config.subDomain === "za" && isGamiclub)
      return `http://n.gamiclub.com/unsubscribe/za?lang=en&token=${uid}`;
    else return "";
  }

  render() {
    let url = window.location.origin;
    this.changeDomain();
    const handleClick = this.handleClick;
    const isAdmin = this.props.isAdmin;
    let navigateItem = isGamiclub
      ? "navigate-item-gamiclub"
      : isGameflares
      ? "navigate-item-gameflares"
      : isGamiway
      ? "navigate-item navigate-item-gamiway"
      : "navigate-item";

    let classNameNotif = this.state.openNotification
      ? `${navigateItem} navigate-dropdown open`
      : `${navigateItem} navigate-dropdown`;
    classNameNotif =
      this.props.currentLang == "ar" ? classNameNotif + " ar" : classNameNotif;

    let classNameLang = this.state.openLanguage
      ? `${navigateItem} navigate-dropdown open`
      : `${navigateItem} navigate-dropdown`;
    classNameLang =
      this.props.currentLang == "ar" ? classNameLang + " ar" : classNameLang;

    let classNameli = navigateItem;
    classNameli =
      this.props.currentLang == "ar" ? classNameli + " ar" : classNameli;
    let classNameSidebar = `sidebar ${
      isGameflares ? "gameflares-sidebar-bg" : ""
    }`;
    classNameSidebar =
      this.props.currentLang == "ar"
        ? classNameSidebar + " ar"
        : classNameSidebar;
    let uid = this.props.access.uid;
    let ppLink, tncLink;
    if (frenchDomain) {
      ppLink =
        "http://n.game-lords.com/ci/tnc-game-lords?offer=1&operator=CI_ORANGE&operatorSubmitted=Y&_next=general_conditions.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&_next=privacy_policy.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&";
      tncLink =
        "http://n.game-lords.com/ci/tnc-game-lords?offer=1&operator=CI_ORANGE&operatorSubmitted=Y&_next=general_conditions.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&";
    } else if (swedishDomain) {
      ppLink = "http://google.com"; //temporary
      tncLink = "http://google.com";
    } else if (config.subDomain === "gr" && !isGamiclub && !isAppspool) {
      ppLink = "https://c1.ouisys.com/static/privacy-gamelords-gr";
      tncLink = "https://c1.ouisys.com/static/terms-gamelords-gr";
    } else if (belgiumDomain) {
      (ppLink =
        "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html"),
        (tncLink =
          "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=general_conditions.html");
    } else if (spanishDomain) {
      (ppLink =
        "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html"),
        (tncLink =
          "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=general_conditions.html");
    } else if (roDomain) {
      tncLink = "http://n.gamiclub.com/ro/tnc-gamiclub?offer=1";
    } else if (config.subDomain === "pt" && isGamiclub) {
      tncLink = "https://c1.mouisys.com/static/terms-gamiclub-pt";
    }

    return (
      <div className={classNameSidebar}>
        <nav className="sidebar-navigate">
          <a
            href={
              config.subDomain === "za" && isGamiclub
                ? undefined
                : appendUid("/#/account", uid)
            }
            onClick={this.hideSideBar}
          >
            <div className="profile">
              <img
                className="profile__image"
                src={
                  this.props.account.user.profilePic
                    ? this.props.account.user.profilePic
                    : "./img/avatar.png"
                }
                alt={this.props.account.user.name}
              />
              {config.subDomain === "za" && isGamiclub ? null : (
                <p className="profile__name">{this.props.account.user.name}</p>
              )}
            </div>
          </a>
          {isAdmin ? (
            <ul className="navigate">
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/welcome", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home"></i>
                  <span>
                    <FormattedMessage
                      id="sidebar.home"
                      defaultMessage="Home"
                      description="Sidebar text"
                    />
                  </span>
                </a>
              </li>
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/domain", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-cogs"></i>
                  <span>Domain</span>
                </a>
              </li>
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/country", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-globe"></i>
                  <span>Country</span>
                </a>
              </li>
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/manage-categories", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-filter"></i>
                  <span>Manage Categories</span>
                </a>
              </li>
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/uploads", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-upload"></i>
                  <span>Upload</span>
                </a>
              </li>
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("/#/manage-user", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-users"></i>
                  <span>Manage Users</span>
                </a>
              </li>
            </ul>
          ) : (
            <ul className="navigate">
              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={
                    swedishDomain ||
                    maseDomain ||
                    myDomain ||
                    config.subDomain == "th" ||
                    config.subDomain === "rsma" ||
                    (window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae')
                      ? appendUid("/#/home/html", uid)
                      : config.subDomain == "pk"
                      ? appendUid("/#/home/android", uid)
                      : appendUid("/#/welcome", uid)
                  }
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home"></i>
                  <span>
                    <FormattedMessage
                      id="sidebar.home"
                      defaultMessage="Home"
                      description="Sidebar text"
                    />
                  </span>
                </a>
              </li>
              {config.subDomain === "za" && isGamiclub ? null : (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("/#/account", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-user-circle-o"></i>
                    <span>
                      <FormattedMessage
                        id="sidebar.myaccount"
                        defaultMessage="My Account"
                        description="Sidebar text"
                      />
                    </span>
                  </a>
                </li>
              )}
              <li className={classNameNotif}>
                <a
                  className="navigate-link navigate-dropdown-toggle"
                  onClick={handleClick.bind(this, "notification")}
                >
                  <i className="fa fa-bell"></i>
                  <span className="children">
                    <div className="notif">
                      <FormattedMessage
                        id="sidebar.notif"
                        defaultMessage="Notification"
                      />
                      <i className="expand"></i>
                    </div>
                  </span>
                </a>
                <ul className="navigate-dropdown-items">
                  <li className={classNameli}>
                    <a className="navigate-link">
                      <span>
                        <FormattedMessage
                          id="sidebar.nonotif"
                          defaultMessage="You have no notifications yet"
                        />
                      </span>
                    </a>
                  </li>
                </ul>
              </li>

              {config.subDomain !== "pk" && (
                <li
                  className={
                    this.props.currentLang == "ar"
                      ? `${navigateItem} navigate-dropdown ar`
                      : `${navigateItem} navigate-dropdown`
                  }
                >
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    href={appendUid("/#/home/html", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-html5"></i>
                    <span className="children">
                      <FormattedMessage
                        id="html5games"
                        defaultMessage="HTML5 Games"
                      />
                    </span>
                  </a>
                </li>
              )}

              {maseDomain ||
              myDomain ||
              config.subDomain == "th" ||
              config.subDomain === "rsma" ||
              config.subDomain === "maae" ||
              (window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae') ||
              (config.subDomain === "za" && isIos) ? (
                ""
              ) : (
                <li
                  className={
                    this.props.currentLang == "ar"
                      ? `${navigateItem} navigate-dropdown ar`
                      : `${navigateItem} navigate-dropdown`
                  }
                >
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    href={appendUid("/#/home/android", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-android"></i>
                    <span className="children">
                      <FormattedMessage
                        id="androidGames"
                        defaultMessage="ANDROID Games"
                      />
                    </span>
                  </a>
                </li>
              )}

              {((isGamiclub || isGamiway) &&
                !(isOnlyMobbfun && config.subDomain === "id") &&
                !(window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae') &&
                config.subDomain !== "rsma") ||
              config.subDomain === "kw" ||
              config.subDomain === "pt" ? (
                <li
                  className={
                    this.props.currentLang == "ar"
                      ? `${navigateItem} navigate-dropdown ar`
                      : `${navigateItem} navigate-dropdown`
                  }
                >
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    href={appendUid("/#/home/video", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-video-camera"></i>
                    <span className="children">
                      <FormattedMessage id="videos" defaultMessage="VIDEOS" />
                    </span>
                  </a>
                </li>
              ) : null}

              {config.subDomain == "sa" && !isGamezClan && (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={"http://sa.vidzclubs.com/?uid=fdf098fcc6"}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-play"></i>
                    <span>
                      <FormattedMessage
                        id="vod"
                        defaultMessage="Video-on-Demand"
                      />
                    </span>
                  </a>
                </li>
              )}

              {getContactPageURL() ? (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={getContactPageURL()}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-question"></i>
                    <span>
                      <FormattedMessage id="help" defaultMessage="Contact Us" />
                    </span>
                  </a>
                </li>
              ) : null}

              <li className={classNameli}>
                <a
                  className="navigate-link"
                  href={appendUid("#/favorites", uid)}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-star"></i>
                  <span>
                    <FormattedMessage id="favorite" defaultMessage="Favorite" />
                  </span>
                </a>
              </li>

              {/* Lang Tab  */}
              {config.subDomain === "dz" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("ar")}
                      >
                        <span
                          className={
                            this.props.currentLang == "ar" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.ar"
                            defaultMessage="ar"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          className={
                            this.props.currentLang == "fr" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="fr"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain === "be" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("be")}
                      >
                        <span
                          className={
                            this.props.currentLang == "be" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.be"
                            defaultMessage="Dutch"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          className={
                            this.props.currentLang == "fr" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          className={
                            this.props.currentLang == "de" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain === "eg" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("ar")}
                      >
                        <span
                          className={
                            this.props.currentLang == "ar" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.ar"
                            defaultMessage="Arabic"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={
                            this.props.currentLang == "en" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain === "ch" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          className={
                            this.props.currentLang == "fr" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          className={
                            this.props.currentLang == "de" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("it")}
                      >
                        <span
                          className={
                            this.props.currentLang == "it" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.it"
                            defaultMessage="Italian"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={
                            this.props.currentLang == "en" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain === "pl" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("pl")}
                      >
                        <span
                          className={
                            this.props.currentLang == "pl" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.pl"
                            defaultMessage="Polish"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={
                            this.props.currentLang == "en" ? "activeLang" : ""
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              <li
                style={
                  isGamiclub
                    ? { backgroundColor: "green" }
                    : isGameflares
                    ? { backgroundColor: "#FF394B" }
                    : null
                }
                className={
                  arabicDomain ||
                  kazakhDomain ||
                  norwayDomain ||
                  vietnamDomain ||
                  turkeyDomain ||
                  spanishDomain ||
                  rsDomain ||
                  url.indexOf("dz") >= 0 ||
                  italianDomain
                    ? ""
                    : "divider"
                }
              ></li>
              {
                config.subDomain === "za" &&
                  !(
                    isAppspool ||
                    isGameflares ||
                    isGamezClan ||
                    isGamiway ||
                    isTheGamingClubs
                  ) && (
                    <li className={classNameli} style={{ padding: "0.5rem 0" }}>
                      <span
                        style={{
                          marginLeft: "9%",
                        }}
                      >
                        <FormattedMessage
                          id="unsubscribe-ZA"
                          defaultMessage="To unsubscribe, dial 135*997#"
                        />
                      </span>
                    </li>
                  )
                //   <li className={classNameli}>
                //                 <a className='navigate-link' onClick={(e) => {
                //                     e.preventDefault();
                //                     const unsublink = this.getUnsubLink()
                //                     if(unsublink) window.location = unsublink
                //                 }}>
                //                     <i className='fa fa-ban'></i>
                //                     <span>
                //                         <FormattedMessage id="unsubscribe" defaultMessage="Unsubscribe" />
                //                     </span>
                //                 </a>
                //         </li>
              }
              <li className={classNameli}>
                {arabicDomain ||
                kazakhDomain ||
                norwayDomain ||
                vietnamDomain ||
                turkeyDomain ||
                spanishDomain ||
                url.indexOf("dz") >= 0 ||
                italianDomain ||
                config.subDomain === "eg" ||
                (config.subDomain === "be" && isGamiclub) ||
                config.subDomain === "pe" ? (
                  <span></span>
                ) : frenchDomain ||
                  swedishDomain ||
                  (belgiumDomain && !isGamiclub) ? (
                  <a
                    className="navigate-link"
                    onClick={(e) => {
                      window.location = ppLink;
                    }}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage
                        id="privacyPolicy"
                        defaultMessage="Policy Privacy"
                      />
                    </span>
                  </a>
                ) : (
                  <a
                    className="navigate-link"
                    href={appendUid("#/privacy-policy", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage
                        id="privacyPolicy"
                        defaultMessage="Policy Privacy"
                      />
                    </span>
                  </a>
                )}
              </li>
              {config.subDomain === "ch" && config.lang === "de" ? (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("#/agb", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage id="agb" defaultMessage="AGB" />
                    </span>
                  </a>
                </li>
              ) : null}
              {config.subDomain === "ch" && config.lang === "de" ? (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("#/hilfe", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage id="hilfe" defaultMessage="Hilfe" />
                    </span>
                  </a>
                </li>
              ) : null}
              {config.subDomain === "ch" && config.lang === "de" ? (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("#/impressum", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage
                        id="impressum"
                        defaultMessage="Impressum"
                      />
                    </span>
                  </a>
                </li>
              ) : null}
              {config.subDomain === "ch" && config.lang === "de" ? (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("#/abo-verwaltung", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage
                        id="aboVerwaltung"
                        defaultMessage="Abo Verwaltung"
                      />
                    </span>
                  </a>
                </li>
              ) : null}
              <li className={classNameli}>
                {arabicDomain ||
                kazakhDomain ||
                norwayDomain ||
                vietnamDomain ||
                turkeyDomain ||
                spanishDomain ||
                config.subDomain === "dz" ||
                italianDomain ||
                deDomain ||
                config.subDomain === "eg" ||
                (config.subDomain === "gr" && isGamiclub) ||
                config.subDomain === "cz" ||
                (config.subDomain === "be" && isGamiclub) ||
                config.subDomain === "pe" ||
                (config.subDomain === "nl" && isGamiclub) ||
                (config.subDomain === "sn" && isGamiclub) ? (
                  <span></span>
                ) : frenchDomain ||
                  swedishDomain ||
                  (belgiumDomain && !isGamiclub) ||
                  (config.subDomain === "gr" && !isGamiclub && !isAppspool) ||
                  (config.subDomain === "pt" && isGamiclub) ? (
                  <a
                    className="navigate-link"
                    onClick={(e) => {
                      window.location = tncLink;
                    }}
                  >
                    <i className="fa fa-file-text-o"></i>
                    <span>
                      <FormattedMessage
                        id="tnc"
                        defaultMessage="Terms &amp; Conditions"
                      />
                    </span>
                  </a>
                ) : (
                  <a
                    className="navigate-link"
                    href={appendUid("#/terms-conditions", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-file-text-o"></i>
                    <span>
                      <FormattedMessage
                        id="tnc"
                        defaultMessage="Terms &amp; Conditions"
                      />
                    </span>
                  </a>
                )}
              </li>
              {config.subDomain === "gr" && isGamelords && (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("/#/contact-us", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-file-text-o"></i>
                    <span>
                      <FormattedMessage
                        id="sidebar.contact"
                        defaultMessage="Contact Us"
                        description="Sidebar text"
                      />
                    </span>
                  </a>
                </li>
              )}
              {config.subDomain === "gr" && isGamelords && (
                <li className={classNameli}>
                  <a
                    className="navigate-link"
                    href={appendUid("/#/faq", uid)}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-file-text-o"></i>
                    <span>
                      <FormattedMessage
                        id="sidebar.faq"
                        defaultMessage="Faq"
                        description="Sidebar text"
                      />
                    </span>
                  </a>
                </li>
              )}
            </ul>
          )}
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.CategoryReducer,
    account: state.AccountReducer,
    access: state.WelcomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLangAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js